import Vue from "vue";
import Router from "vue-router";
import mianIndex from "@/components/main/main";
import hourAvg from "@/components/analysis/hourAvg";
import avgOver from "@/components/analysis/avgOver";
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "login",
      component: (resolve) => require(["@/login"], resolve),
    },
    {
      path: "/error",
      name: "error",
      component: (resolve) => require(["@/error"], resolve),
    },
    {
      path: "/main",
      name: "main",
      component: (resolve) => require(["@/views/main"], resolve),
      children: [
        {
          path: "/main",
          name: "mianIndex",
          component: mianIndex,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/main/curve",
          component: (resolve) => require(["@/components/main/curve"], resolve),
          name: "curve",
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/main/datacompare",
          component: (resolve) =>
            require(["@/components/main/datacompare"], resolve),
          name: "datacompare",
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/main/forecast",
          component: (resolve) =>
            require(["@/components/main/forecast"], resolve),
          name: "forecast",
          meta: {
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "/detail",
      name: "detail",
      component: (resolve) => require(["@/views/detail"], resolve),
      children: [
        {
          path: "/detail",
          component: (resolve) =>
            require(["@/components/detail/detail"], resolve),
          name: "spotdetail",
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/detail/history",
          component: (resolve) =>
            require(["@/components/detail/history"], resolve),
          name: "historyData",
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/detail/hlsvideo",
          component: (resolve) =>
            require(["@/components/detail/hlsvideo"], resolve),
          name: "hlsvideo",
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/detail/image",
          component: (resolve) =>
            require(["@/components/detail/image"], resolve),
          name: "image",
          meta: {
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "/analysis",
      name: "analysis",
      component: (resolve) => require(["@/views/analysis"], resolve),
      children: [
        {
          path: "/analysis",
          component: hourAvg,
          name: "hourAvg",
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/analysis/avgOver",
          component: avgOver,
          name: "avgOver",
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/analysis/compareToStation",
          component: (resolve) =>
            require(["@/components/analysis/compareToStation"], resolve),
          name: "compareToStation",
          meta: {
            requireAuth: true,
          },
        },
        {
          path: "/analysis/spotCalendar",
          component: (resolve) =>
            require(["@/components/analysis/spotCalendar"], resolve),
          name: "spotCalendar",
          meta: {
            requireAuth: true,
          },
        },
        {
          path: "/analysis/rankAvg",
          component: (resolve) =>
            require(["@/components/analysis/rankAvg"], resolve),
          name: "rankAvg",
          meta: {
            requireAuth: true,
          },
        },
        {
          path: "/analysis/monthCompare",
          component: (resolve) =>
            require(["@/components/analysis/monthCompare"], resolve),
          name: "monthCompare",
          meta: {
            requireAuth: true,
          },
        },
        {
          path: "/analysis/wholeRank",
          // component: monthCompare,
          component: (resolve) =>
            require(["@/components/analysis/wholeRank"], resolve),
          name: "wholeRank",
          meta: {
            requireAuth: true,
          },
        },
        {
          path: "/analysis/intelligentAnalysis",
          // component: monthCompare,
          component: (resolve) =>
            require(["@/components/analysis/intelligentAnalysis"], resolve),
          name: "intelligentAnalysis",
          meta: {
            requireAuth: true,
          },
        },
      ],
    },
    {
      path: "/operation",
      name: "operation",
      component: (resolve) => require(["@/views/operation"], resolve),
      children: [
        {
          path: "/operation",
          component: (resolve) =>
            require(["@/components/operation/warning"], resolve),
          name: "warning",
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/operation/monitor",
          component: (resolve) =>
            require(["@/components/operation/monitor"], resolve),
          name: "monitor",
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/operation/sendNotice",
          component: (resolve) =>
            require(["@/components/operation/sendNotice"], resolve),
          name: "sendNotice",
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/operation/alertReport",
          component: (resolve) =>
            require(["@/components/operation/alertReport"], resolve),
          name: "alertReport",
          meta: {
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "/law",
      name: "law",
      component: (resolve) => require(["@/views/law"], resolve),
      children: [
        {
          path: "/law",
          component: (resolve) =>
            require(["@/components/law/project"], resolve),
          name: "project",
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/law/leader",
          component: (resolve) => require(["@/components/law/leader"], resolve),
          name: "leader",
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/law/number",
          component: (resolve) => require(["@/components/law/number"], resolve),
          name: "number",
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/law/summary",
          component: (resolve) =>
            require(["@/components/law/summary"], resolve),
          name: "summary",
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/law/punish",
          component: (resolve) => require(["@/components/law/punish"], resolve),
          name: "punish",
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/law/govpunish",
          component: (resolve) =>
            require(["@/components/law/govpunish"], resolve),
          name: "govpunish",
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/law/analysis",
          component: (resolve) =>
            require(["@/components/law/analysis"], resolve),
          name: "analysis",
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/law/people",
          component: (resolve) => require(["@/components/law/people"], resolve),
          name: "people",
          meta: {
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path:'/report',
      name:'report', 
      component: (resolve) => require(["@/views/report"], resolve),
    },
    {
      path: "/backVideo",
      component: (resolve) =>
        require(["@/components/operation/backVideo"], resolve),
      name: "backVideo",
    },
    {
      path: "/manage",
      name: "manage",
      component: (resolve) => require(["@/views/manage"], resolve),
      children: [
        {
          path: "/manage",
          component: (resolve) =>
            require(["@/components/manage/warmSetting"], resolve),
          name: "warmSetting",
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/manage/timeTask",
          component: (resolve) =>
            require(["@/components/manage/timeTask"], resolve),
          name: "timeTask",
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/manage/handleChange",
          component: (resolve) =>
            require(["@/components/manage/handleChange"], resolve),
          name: "handleChange",
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/manage/checkGps",
          component: (resolve) =>
            require(["@/components/manage/checkGps"], resolve),
          name: "checkGps",
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/manage/checkCase",
          component: (resolve) =>
            require(["@/components/manage/checkCase"], resolve),
          name: "checkCase",
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/manage/troubleShoot",
          component: (resolve) =>
            require(["@/components/manage/troubleShoot"], resolve),
          name: "troubleShoot",
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/manage/pollutionManage",
          component: (resolve) =>
            require(["@/components/manage/pollutionManage"], resolve),
          name: "pollutionManage",
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/manage/videoCheck",
          component: (resolve) =>
            require(["@/components/manage/videoCheck"], resolve),
          name: "videoCheck",
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/manage/parameterSet",
          component: (resolve) =>
            require(["@/components/manage/parameterSet"], resolve),
          name: "parameterSet",
          meta: {
            requiresAuth: true,
          },
        },
      ],
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js